export default __webpack_public_path__ + "static/media/logo.ef9abc44.png";